// extracted by mini-css-extract-plugin
export default {"rowContainer":"Permissions_rowContainer__nGQpZ","singleRow":"Permissions_singleRow__Oz7Qt","permissionsModalHeader":"Permissions_permissionsModalHeader__Xukwl"};